import { useState } from "react";
import { cx, gradientFor, initials } from "../../utils";

const sizes = {
  sm: "h-9 w-9 rounded-lg text-[11px]",
  md: "h-11 w-11 rounded-xl text-sm",
  lg: "h-14 w-14 rounded-2xl text-base",
  xl: "h-16 w-16 rounded-2xl text-lg",
};

/**
 * App avatar. Falls back to initials on a deterministic gradient when there is
 * no appImage, or when the image fails to load.
 */
const AppIcon = ({ app = {}, size = "md", className = "" }) => {
  const [broken, setBroken] = useState(false);
  const name = app.appName || "";
  const cls = cx(sizes[size] || sizes.md, "shrink-0 ring-1 ring-ink-900/5", className);

  if (app.appImage && !broken) {
    return (
      <img
        src={app.appImage}
        alt=""
        onError={() => setBroken(true)}
        className={cx(cls, "object-cover bg-white")}
      />
    );
  }

  return (
    <div
      className={cx(
        cls,
        "grid place-items-center bg-gradient-to-br font-bold text-white",
        gradientFor(app.appId || name),
      )}
      aria-hidden
    >
      {initials(name)}
    </div>
  );
};

export default AppIcon;
